export default (timelineValues: number[] | string[]): boolean =>
    timelineValues && timelineValues.length && timelineValues.length < 65;
